// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import { ChannelAsset, ChannelStellarAsset } from "./channelState";
import { jsonBigIntMember } from "./bigint";
import { AssetType } from "./ethereumAsset";

@jsonObject()
class StellarAsset {
  @jsonMember(String) public code: string;
  @jsonMember(String) public name: string;
  @jsonMember(String) public type: AssetType;
  @jsonMember(String) public contractID: string;
  @jsonBigIntMember() public chainID: bigint;

  constructor(
    code: string,
    name: string,
    type: AssetType,
    address: string,
    chainID: bigint,
  ) {
    this.code = code;
    this.name = name;
    this.type = type;
    this.contractID = address;
    this.chainID = chainID;
  }

  assetID = () => makeAssetID(this.contractID, this.code);

  get isNativeToken() {
    return this.type === "native";
  }

  toChannelAsset(): ChannelAsset {
    return new ChannelStellarAsset(this.contractID);
  }
  toChannelStellarAsset(): ChannelStellarAsset {
    return new ChannelStellarAsset(this.contractID);
  }
}

// The AssetID is the unique identifier for assets and is generated by the
// asset's address and chain ID of the chain it lives on.
export type AssetID = string;

export function makeAssetID(address: string, code: string): AssetID {
  return address + code.toString();
}

export default StellarAsset;
